export default __webpack_public_path__ + "static/media/Hack-free.2212b4de.svg";